import {
    Button,
    // Flex,
    FormControl,
    FormLabel,
    // Heading,
    Stack,
    useColorModeValue,
  } from '@chakra-ui/react'
import { useState } from "react";
import { useUserChangedPasswordMutation } from "../../slices/adminApiSlice";
import { useNavigate } from 'react-router-dom';
import { ToastService } from '../../services/toast/toastService';
import { PasswordField } from '../../components/PasswordField';

const AdminChangePasswordScreen = () => {
 
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { success, error } = ToastService();
  const navigate = useNavigate();
  const [ changedPassword, { isLoading } ] = useUserChangedPasswordMutation();
  const bgColor = useColorModeValue('gray.50', 'gray.700');

  const submitHandler = async (e) => {
    e.preventDefault();
   
    // Basic validation: check if passwords match
    if (newPassword !== confirmPassword) {
        error('Passwords do not match!');
        return;
    }

    if (!currentPassword || !newPassword || !confirmPassword) {
        error('Please fill all fields');
        return;
    }

    try {
        const payload = {
        currentPassword,
        newPassword,
        };

        await changedPassword(payload).unwrap();
        success("Password changed successfully.");

        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');

    } catch(err) {
        //console.log(err)
        error(err.data?.message || 'An unexpected error occurred.')
    }
  };

  const cancelHandler = async (e) => {
    navigate('/admin');
  }


  return (
    
      <Stack
        spacing={4}
        w={'full'}
        maxW={'lg'}
        bg={bgColor}
        rounded={'lg'}
        boxShadow={'2xl'}
        p={6}
       >
        {/* <Heading lineHeight={1.1} fontSize={{ base: '2xl', sm: '3xl' }}>
          Admin Change Password
        </Heading> */}
        <form onSubmit={submitHandler}>
        <FormControl id="currentPassword" mt={4} isRequired>
        <FormLabel>Current Password</FormLabel>
            <PasswordField id="currentPassword" showStrengthBar={false} value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} />
        </FormControl>
        <FormControl id="newPassword" mt={4} isRequired>
        <FormLabel>New Password</FormLabel>
            <PasswordField id="newPassword" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
        </FormControl>
        <FormControl id="confirmPassword" mt={4} isRequired>
        <FormLabel>Confirm Password</FormLabel>
            <PasswordField 
                id="confirmPassword" 
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
            />
        </FormControl>
        
        <Stack spacing={6} direction={['column', 'row']}>
          <Button
            type="submit"
            colorScheme='teal'
            variant={'outline'}
            width="full" 
            mt={4}
            _hover={{ bg: 'teal.500', color: 'white' }} 
            //onClick={submitHandler}
            isLoading={isLoading}>
            Save
          </Button>
          <Button
            colorScheme='red'
            variant={'outline'}
            width="full" 
            mt={4}
            _hover={{ bg: 'red.500', color: 'white' }} 
            onClick={cancelHandler}>
            Cancel
          </Button>
        </Stack>
        </form>
      </Stack>
    
  )
}

export default AdminChangePasswordScreen;